import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  Button,
  Checkbox,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  SimpleGrid,
  Skeleton,
  Spinner,
  Table,
  Tag,
  TagCloseButton,
  TagLabel,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  useDisclosure,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import {
  MdArrowDropDown,
  MdCheckCircle,
  MdCloudDownload,
  MdOutlineFilterAlt,
  MdSearch,
} from "react-icons/md";

import Card from "../../../components/card/Card";
import { Player } from "@lottiefiles/react-lottie-player";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import OrderDrawer from "./components/OrderDrawer";
import { useAuth0 } from "@auth0/auth0-react";
import {
  useLocations,
  useSales,
  useSalesPersons,
  useStatus,
  useOrderMetrics,
} from "../../../lib/hooks";
import { mutate } from "swr";
import moment from "moment/moment";
import IconBox from "../../../components/icons/IconBox";
import { usePagination, useTable } from "react-table";

function Sales(props) {
  let statusSelectedItems = [];
  let locationSelectedItems = [];

  const [pageHook, setPageHook] = useState(1);
  const [per_page, setPer_page] = useState(100);
  const [selectedOrder, setSelectedOrder] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [filteredData, setFilterdData] = useState([]);
  const [filterNotFound, setFilterNotFound] = useState(false);
  const [orderRef, setOrderRef] = useState("");
  const [invoiceRef, setInvoiceRef] = useState("");
  const [agentRef, setAgentRef] = useState("");
  const [mobileRef, setMobileRef] = useState("");
  const [emiratesRef, setEmiratesRef] = useState("");
  const [emiDues, setEmiDues] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [filterTotalCount, setFilterTotalCount] = useState(0);
  const [filterArray, setFilterArray] = useState([]);
  const [filterArrayPayload, setFilterArrayPayload] = useState("");
  const [filterLoading, setFilterLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [selectRef, setSelectRef] = useState("");
  const [locationSelectRef, setLocationSelectRef] = useState("");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const { user, isLoading: userLoading, error } = useAuth0();
  const [mounted, setMounted] = useState(false);
  const {
    sales,
    isError: salesError,
    isLoading,
  } = useSales(mounted, pageHook, per_page, filterArrayPayload);

  const {
    metrics,
    isError: metricsError,
    isLoading: metricsLoading,
  } = useOrderMetrics(mounted);
  
  const {
    salesPersons,
    isLoading: salesPersonLoading,
    isError: salesPersonError,
  } = useSalesPersons();
  const [statusItemSelect, setStatusItemSelect] = useState(statusSelectedItems);
  const [locationItemSelect, setLocationItemSelect] = useState(
    locationSelectedItems
  );
  const [filterCount, setFilterCount] = useState(0);
  const boxesColor = useColorModeValue("white", "#1B254B");

  useEffect(() => {
    const token = localStorage.getItem("auth0_token");
    if (user && !userLoading && token) {
      setMounted(true);
      mutate(`orders/samsung?page=${pageHook}&per-page=${per_page}`);
    }
  }, [onClose, onOpen]);


  const userRole = user?.["https://admin.b2connect.me/roles"][0];
  const {
    status: orderStatus,
    isError: OstatusError,
    isLoading: OstatusLoading,
  } = useStatus(mounted);

  const {
    locations,
    isError: locationError,
    isLoading: loactionLoading,
  } = useLocations(mounted);
  const {
    status,
    isError: statusError,
    isLoading: statusLoading,
  } = useStatus(mounted);

  const salesData =
    !salesError && !isLoading && sales && filteredData.length == 0
      ? sales?.body?.items?.map((item, i) => ({
          date: (
            <Flex w={"max-content"}>
              {" "}
              <Tooltip
                label={moment(item.time)
                  .utc()
                  .format("MMMM Do YYYY, h:mm:ss a")}
              >
                {moment(item.time).utc().format("LL")}
              </Tooltip>
            </Flex>
          ),
          dateEX: item.time,

          orderNo: item.salesOrderNo ? (
            <Flex>
              {" "}
              <Text w={"max-content"}>{item.salesOrderNo}</Text>
            </Flex>
          ) : (
            <>
              <Text color={"gray"}>No Order #ID</Text>
            </>
          ),
          orderNoEX: item.salesOrderNo,

          salesOrderId: item.orderId ? (
            <Flex>
              {" "}
              <Text w={"max-content"}>{item.orderId}</Text>
            </Flex>
          ) : (
            <>
              <Text color={"gray"}>No Order #ID</Text>
            </>
          ),
          invoiceNo: item.invoiceNo ? (
            <Flex w={"max-content"}>{item.invoiceNo}</Flex>
          ) : (
            <>
              <Text color={"gray"} w={"max-content"}>
                No Invoice Number
              </Text>
            </>
          ),
          invoiceNoExport: item.invoiceNo,
          status: (
            <Badge>
              {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
            </Badge>
          ),
          source:
            item.source == "APP" ? (
              <Flex flexDir={"row"}>
                <IconBox
                  w="22px"
                  h="22px"
                  icon={
                    <Player
                      autoplay
                      loop
                      src="https://assets1.lottiefiles.com/private_files/lf30_xtkkgbco.json"
                      style={{ height: "22px", width: "22px" }}
                    ></Player>
                  }
                />

                <IconBox
                  w="22px"
                  h="22px"
                  icon={
                    <Player
                      autoplay
                      loop
                      src="https://assets2.lottiefiles.com/temp/lf20_dFXDxA.json"
                      style={{ height: "52px", width: "52px" }}
                    ></Player>
                  }
                />
              </Flex>
            ) : (
              <span>{item.source}</span>
            ),
          location: item.userZone ? (
            <Flex w={"max-content"}>{item.userZone}</Flex>
          ) : (
            <>
              <Text color={"gray"} w={"max-content"}>
                No Location
              </Text>
            </>
          ),
          phone: item.userPhone ? (
            item.userPhone
          ) : (
            <>
              <Text color={"gray"}>Not Provided</Text>
            </>
          ),
          locationExport: item.userZone,
          total: `AED ${item.total}`,
          orderId: item.orderId,
          salesAgentCode: item.salesAgentCode,
          statusExport: item.status,
          sourceExport: item.source,
          paymentMethod: item.paymentMethod,
        }))
      : filteredData?.map((item) => ({
          date: moment(item.time).utc().format("LL"),
          orderNo: item.salesOrderNo,
          invoiceNo: item.invoiceNo,
          salesAgent: item.salesAgentCode,
          status: (
            <Badge>
              {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
            </Badge>
          ),

          source:
            item.source == "APP" ? (
              <Flex flexDir={"row"}>
                <IconBox
                  w="22px"
                  h="22px"
                  icon={
                    <Player
                      autoplay
                      loop
                      src="https://assets1.lottiefiles.com/private_files/lf30_xtkkgbco.json"
                      style={{ height: "22px", width: "22px" }}
                    ></Player>
                  }
                />

                <IconBox
                  w="22px"
                  h="22px"
                  icon={
                    <Player
                      autoplay
                      loop
                      src="https://assets2.lottiefiles.com/temp/lf20_dFXDxA.json"
                      style={{ height: "52px", width: "52px" }}
                    ></Player>
                  }
                />
              </Flex>
            ) : (
              <span>{item.source} 2</span>
            ),
          location: item.userZone,
          phone: "0" + item.userPhone.substring(3),
          method: item.paymentMethod,
          total: item.total,
          orderId: item.orderId,
          salesAgentCode: item.salesAgentCode,
          statusExport: item.status,
          locationExport: item.userZone,
          sourceExport: item.source,
          paymentMethod: item.paymentMethod,
        }));

  const data = React.useMemo(() => salesData, [sales, filteredData]);

  // Search filter function
  const filteredDataBySearch = React.useMemo(() => {
    if (!searchTerm) return data;

    return data.filter((item) => {
      const searchLower = searchTerm.toLowerCase();

      // Search across all relevant fields
      const searchableFields = [
        item.orderNoEX,
        item.invoiceNoExport,
        item.salesAgentCode,
        item.phone,
        item.locationExport,
        item.statusExport,
        item.sourceExport,
        item.orderId,
        item.total,
        item.paymentMethod,
      ];

      return searchableFields.some(
        (field) => field && field.toString().toLowerCase().includes(searchLower)
      );
    });
  }, [data, searchTerm]);


  const columns = React.useMemo(
    () => {
      const baseColumns = [
        {
          Header: "Date",
          accessor: "date",
        },
        {
          Header: "Order #",
          accessor: "orderNo",
        },
        {
          Header: "Internal Order ID",
          accessor: "salesOrderId",
        },
        {
          Header: "Invoice #",
          accessor: "invoiceNo",
        },
        {
          Header: "Location",
          accessor: "location",
        },
        {
          Header: "Mobile Number",
          accessor: "phone",
        },
        {
          Header: "Sales Agent Code",
          accessor: "salesAgentCode",
        },
      ];



      return [
        {
          Header: " ",
          columns: baseColumns,
        },
        {
          Header: " ",
          columns: [
            {
              Header: "Status",
              accessor: "status",
            },
            {
              Header: "Total",
              accessor: "total",
            },
          ],
        },
      ];
    },
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data: filteredDataBySearch,
      useControlledState: (state) => {
        return React.useMemo(
          () => ({
            ...state,
            pageIndex: pageHook,
          }),
          [state, pageHook]
        );
      },
      initialState: { pageIndex: pageHook },
      manualPagination: true,
      pageCount: 20,
    },
    usePagination
  );
  const filterButtonReset = () => {
    setOrderRef("");
    setMobileRef("");
    setInvoiceRef("");
    setAgentRef("");
    setSelectedOrder(0);
    setFilterdData([]);
    setFilterNotFound(false);
    setFilterTotalCount(0);
    setFilterArray([]);
    setFilterArrayPayload("");
    setSelectRef("");
    setLocationSelectRef("");
    setStatusItemSelect([]);
    setLocationItemSelect([]);
    setEmiDues(false);
    setEmiratesRef("");
    setFilterCount(0);
    setPageHook(1);
    setSearchTerm("");
  };

  const handleMetricCardClick = async (statusType) => {
    // Reset existing filters first
    setOrderRef("");
    setMobileRef("");
    setInvoiceRef("");
    setAgentRef("");
    setSelectedOrder(0);
    setFilterdData([]);
    setFilterNotFound(false);
    setFilterTotalCount(0);
    setFilterArray([]);
    setFilterArrayPayload("");
    setSelectRef("");
    setLocationSelectRef("");
    setStatusItemSelect([]);
    setLocationItemSelect([]);
    setEmiDues(false);
    setEmiratesRef("");
    setFilterCount(0);
    setPageHook(1);
    setSearchTerm("");

    // Set up status filter based on the clicked metric
    let statusToFilter = [];

    switch (statusType) {
      case 'rejected':
        statusToFilter = ['rejected', 'rejected (no stock)', 'rejected (EID)', 'rejected (duplicate order)', 'rejected (new SKU)', 'rejected (no answer)'];
        break;
      case 'delivered':
        statusToFilter = ['delivered'];
        break;
      case 'deliveredAwaitPayment':
        statusToFilter = ['delivered (await next payment)'];
        break;
      case 'pendingNoStock':
        statusToFilter = ['pending (no stock)'];
        break;
      case 'completed':
        statusToFilter = ['completed'];
        break;
      case 'cancelled':
        statusToFilter = ['cancelled (refund claimed)'];
        break;
      case 'totalOrders':
        // For total orders, reset all filters and show all data
        return;
      default:
        return;
    }

    // Apply the filter immediately by building the filter array
    setFilterLoading(true);

    let filterArrayAdvanced = [];
    let statusesArray = [];
    statusToFilter.forEach((item) => {
      statusesArray.push(item);
    });

    filterArrayAdvanced.push({
      type: "STATUS",
      value: statusesArray.toString().replaceAll(",", ";"),
    });

    // Build the filter payload
    let arrayToGo = [];
    filterArrayAdvanced.forEach((item) => {
      arrayToGo.push(`${item.type}:${item.value}`);
    });

    // Set the filter state and payload
    const statusFilters = statusToFilter.map(status => ({ status, id: status }));
    setStatusItemSelect(statusFilters);
    setFilterArrayPayload(arrayToGo.toString());
    setFilterCount(1);
    setFilterLoading(false);
    setPageHook(1);
  };

  const orderInit = (item) => {
    setSelectedOrder({});
    if (item) {
      setSelectedOrder(item);
      onOpen();
    }
  };
  const handleSelectFilter = async (event) => {
    const statusElm = {
      status: event.target.value,
      active: true,
    };
    setStatusItemSelect((statusSelectedItems) => [
      ...statusSelectedItems,
      statusElm,
    ]);
  };

  const handleLocationFilter = async (event) => {
    const locationElement = {
      location: event.target.value,
      active: true,
    };
    setLocationItemSelect((locationItemSelect) => [
      ...locationItemSelect,
      locationElement,
    ]);
  };
  const handleAdvancedFilter = (event, type) => {
    if (type === "status") {
      handleSelectFilter(event);
    }
    if (type === "location") {
      handleLocationFilter(event);
    }
  };

  const statusListRemove = (event) => {
    const filterd = statusItemSelect.filter((item) => item.status !== event);
    setStatusItemSelect(filterd);
  };

  const locationListRemove = (event) => {
    const filterd = locationItemSelect.filter(
      (item) => item.location !== event
    );
    setLocationItemSelect(filterd);
  };

  const handleMultiFilter = () => {
    setFilterLoading(true);

    let filterArrayAdvanced = [];

    if (emiDues) {
      filterArrayAdvanced.push({
        type: "IS_NEXT_DUE",
        value: "TRUE",
      });
      setFilterCount(filterCount + 1);
      setPageHook(1);
    }

    if (emiratesRef) {
      filterArrayAdvanced.push({
        type: "EMIRATES_ID",
        value: emiratesRef,
      });
      setFilterCount(filterCount + 1);
      setPageHook(1);
    }
    if (mobileRef) {
      var mobD = mobileRef;
      if (mobD.slice(0, 3) === "971") {
        filterArrayAdvanced.push({
          type: "MOBILE_NUMBER",
          value: mobD.slice(3),
        });
      } else if (mobD.charAt(0) == "0") {
        filterArrayAdvanced.push({
          type: "MOBILE_NUMBER",
          value: mobD.slice(1),
        });
      } else if (mobD.charAt(0) == "5") {
        filterArrayAdvanced.push({
          type: "MOBILE_NUMBER",
          value: mobD,
        });
      }

      setFilterCount(filterCount + 1);
      setPageHook(1);
    }
    if (agentRef) {
      filterArrayAdvanced.push({
        type: "SALES_AGENT",
        value: agentRef,
      });
      setFilterCount(filterCount + 1);
      setPageHook(1);
    }
    if (invoiceRef) {
      filterArrayAdvanced.push({
        type: "INVOICE_NO",
        value: `INV-${invoiceRef}`,
      });
      setFilterCount(filterCount + 1);
      setPageHook(1);
    }
    if (orderRef) {
      filterArrayAdvanced.push({
        type: "ORDER_NO",
        value: `PI-${orderRef}`,
      });
      setFilterCount(filterCount + 1);
      setPageHook(1);
    }
    if (statusItemSelect.length > 0) {
      let statusesArray = [];
      statusItemSelect.forEach((item) => {
        statusesArray.push(item.status);
      });
      setFilterCount(filterCount + 1);

      filterArrayAdvanced.push({
        type: "STATUS",
        value: statusesArray.toString().replaceAll(",", ";"),
      });
    }
    if (locationItemSelect.length > 0) {
      let locationsArrayS = [];
      locationItemSelect.forEach((item) => {
        locationsArrayS.push(item.location);
      });
      setFilterCount(filterCount + 1);

      filterArrayAdvanced.push({
        type: "LOCATION",
        value: locationsArrayS.toString().replaceAll(",", ";"),
      });
      setPageHook(1);
    }

    let arrayToGo = [];
    filterArrayAdvanced.forEach((item) => {
      arrayToGo.push(`${item.type}:${item.value}`);
    });
    setFilterArrayPayload(arrayToGo.toString());

    setFilterLoading(false);
    setPageHook(1);
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function capitalizeWords(string) {
    return string.replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  const filtersCountFn = () => {
    let count = 0;
    if (statusItemSelect.length > 0) {
      count += statusItemSelect.length;
    }
    if (locationItemSelect.length > 0) {
      count += locationItemSelect.length;
    }
    if (agentRef) {
      count += 1;
    }
    if (emiDues) {
      count += 1;
    }
    if (emiratesRef) {
      count += 1;
    }
    if (mobileRef) {
      count += 1;
    }
    if (invoiceRef) {
      count += 1;
    }
    if (orderRef) {
      count += 1;
    }
    return count;
  };

  // Calculate aggregated metrics
  const getAggregatedMetrics = () => {
    if (!metrics?.body) return {};

    const body = metrics.body;
    const rejected = (body.rejected || 0) +
                    (body["rejected (no stock)"] || 0) +
                    (body["rejected (EID)"] || 0) +
                    (body["rejected (duplicate order)"] || 0) +
                    (body["rejected (no answer)"] || 0);

    return {
      totalOrders: body.totalOrders || 0,
      rejected: rejected,
      delivered: body.delivered || 0,
      deliveredAwaitPayment: body["delivered (await next payment)"] || 0,
      pendingNoStock: body["pending (no stock)"] || 0,
      completed: body.completed || 0,
      cancelled: body["cancelled (refund claimed)"] || 0
    };
  };

  const aggregatedMetrics = getAggregatedMetrics();

  // Helper functions for CSV export
  const convertToCSV = (data) => {
    if (!data || data.length === 0) return '';

    const headers = Object.keys(data[0]);
    const csvHeaders = headers.join(',');

    const csvRows = data.map(row => {
      return headers.map(header => {
        const value = row[header];
        // Escape commas and quotes in CSV values
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',');
    });

    return [csvHeaders, ...csvRows].join('\n');
  };

  const downloadCSV = (csvContent, filename) => {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Export functionality
  const handleExport = async () => {
    setExportLoading(true);
    try {
      const token = localStorage.getItem("auth0_token");
      if (!token) {
        setExportLoading(false);
        return;
      }

      // Build filter parameters
      let filterParams = [];

      if (statusItemSelect.length > 0) {
        let statusesArray = [];
        statusItemSelect.forEach((item) => {
          statusesArray.push(item.status);
        });
        filterParams.push(`STATUS:${statusesArray.join(";")}`);
      }

      if (locationItemSelect.length > 0) {
        let locationsArray = [];
        locationItemSelect.forEach((item) => {
          locationsArray.push(item.location);
        });
        filterParams.push(`LOCATION:${locationsArray.join(";")}`);
      }

      if (agentRef) {
        filterParams.push(`SALES_AGENT:${agentRef}`);
      }

      if (mobileRef) {
        var mobD = mobileRef;
        if (mobD.slice(0, 3) === "971") {
          filterParams.push(`MOBILE_NUMBER:${mobD.slice(3)}`);
        } else if (mobD.charAt(0) == "0") {
          filterParams.push(`MOBILE_NUMBER:${mobD.slice(1)}`);
        } else if (mobD.charAt(0) == "5") {
          filterParams.push(`MOBILE_NUMBER:${mobD}`);
        }
      }

      if (invoiceRef) {
        filterParams.push(`INVOICE_NO:INV-${invoiceRef}`);
      }

      if (orderRef) {
        filterParams.push(`ORDER_NO:PI-${orderRef}`);
      }

      if (emiDues) {
        filterParams.push(`IS_NEXT_DUE:TRUE`);
      }

      if (emiratesRef) {
        filterParams.push(`EMIRATES_ID:${emiratesRef}`);
      }

      const filterString = filterParams.length > 0 ? filterParams.join(",") : "";

      // Fetch export data
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/orders/samsung?export=true${filterString ? `&filter-by=${filterString}` : ""}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      console.log("Export API response:", data);

      if (data.success && data.body) {
        // Check if data.body is an array
        const ordersArray = Array.isArray(data.body) ? data.body : data.body.items || [];

        if (ordersArray.length === 0) {
          console.warn("No orders found for export");
          setExportLoading(false);
          return [];
        }

        // Convert to CSV format
        const csvData = ordersArray.map((item) => ({
          Date: moment(item?.time).utc().format("MMMM Do YYYY, h:mm:ss a"),
          "Order Number": item?.salesOrderNo || "No Order #ID",
          "Invoice Number": item?.invoiceNo || "No Invoice Number",
          Status: item?.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "",
          Source: item?.source || "",
          Location: item?.userZone || "No Location",
          "Phone number": item?.userPhone ? "0" + item.userPhone.substring(3) : "Not Provided",
          Total: `AED ${item?.total || 0}`,
          Balance: `AED ${item?.balance || 0}`,
          Tenure: item?.installmentInfo ? `${item.installmentInfo.length} months` : "N/A",
          "Order #ID": item?.orderId || "",
          "Sales Agent Code": item?.salesAgentCode || "",
          "Payment Method": item?.paymentMethod || "",
        }));

        setExportLoading(false);

        // Trigger automatic download
        const csvContent = convertToCSV(csvData);
        downloadCSV(csvContent, `Samsung_Orders_${new Date().toISOString().split('T')[0]}.csv`);

        return csvData;
      }
    } catch (error) {
      console.error("Export failed:", error);
    }
    setExportLoading(false);
    return [];
  };

  return (
    <>
      <Flex></Flex>
      <SimpleGrid mt={20} columns={{ sm: 2, md: 4, lg: 8 }} spacing={3}>
        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#e0457b"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('totalOrders')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Total Orders
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.totalOrders
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#f56565"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('rejected')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Rejected
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.rejected
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#48bb78"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('delivered')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Delivered
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.delivered
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#ed8936"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('deliveredAwaitPayment')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Delivered Await Payment
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.deliveredAwaitPayment
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#f6ad55"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('pendingNoStock')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Pending No Stock
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.pendingNoStock
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#38b2ac"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('completed')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Completed
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.completed
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>

        <Skeleton
          isLoaded={!metricsLoading && !metricsError}
          fadeDuration={1.5}
          borderRadius={20}
        >
          <Box
            bg={boxesColor}
            h={90}
            borderRadius={10}
            borderColor={"#718096"}
            borderWidth={2}
            boxShadow={"sm"}
            cursor="pointer"
            onClick={() => handleMetricCardClick('cancelled')}
            _hover={{ transform: "scale(1.02)", transition: "0.2s" }}
          >
            <Flex flexDir={"column"} p={3} justifyContent={"center"} alignItems={"flex-start"} h="full">
              <Flex>
                <Text fontSize={"xs"} color={textColor}>
                  Cancelled
                </Text>
              </Flex>
              <Flex>
                <Text fontSize={"lg"} color={textColor} fontWeight={600}>
                  {metricsLoading ? (
                    <Spinner size="sm" />
                  ) : (
                    aggregatedMetrics.cancelled
                  )}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Skeleton>
      </SimpleGrid>

      <Box>
        <Box pt={{ base: "180px", md: "80px", xl: "30px" }}>
          <Skeleton
            isLoaded={!isLoading && !salesError}
            fadeDuration={1.5}
            borderRadius={20}
          >
            <Card
              direction="column"
              w="100%"
              px="0px"
              overflowX={{ sm: "scroll", lg: "hidden" }}
            >
              <Flex px="25px" justify="space-between" mb="20px" align="center">
                <Flex>
                  <InputGroup maxW="500px" mr={4}>
                    <InputLeftElement pointerEvents="none">
                      <Icon as={MdSearch} color="gray.400" />
                    </InputLeftElement>
                    <Input
                      placeholder="Search across all fields..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      width="500px"
                    />
                  </InputGroup>
                  {/*<Flex mr={5}>*/}
                  {/*    <Menu>*/}
                  {/*        <MenuButton as={Button} rightIcon={<MdArrowDropDown />}>*/}
                  {/*            Date*/}
                  {/*        </MenuButton>*/}
                  {/*        <MenuList>*/}
                  {/*            <MenuItem>Last Week</MenuItem>*/}
                  {/*            <MenuItem>Last 30 Days</MenuItem>*/}
                  {/*            <MenuItem>Last 3 Months</MenuItem>*/}

                  {/*        </MenuList>*/}
                  {/*    </Menu>*/}
                  {/*</Flex>*/}
                </Flex>
                <Flex alignItems="center">
                  {filterArray.length > 0 && (
                    <Button
                      onClick={() => filterButtonReset()}
                      color={textColor}
                      fontSize="16px"
                      fontWeight="700"
                      lineHeight="100%"
                    >
                      Reset
                    </Button>
                  )}

                  {filterLoading && <Spinner style={{ margin: 10 }} />}
                </Flex>

                <Flex flexDir={"row"}>
                  <Flex>
                    <Popover>
                      <PopoverTrigger>
                        <Button
                          boxShadow={"sm"}
                          borderRadius={5}
                          background={"#f6ad55"}
                          color={"whiteAlpha.900"}
                        >
                          <Flex flexDir={"row"}>
                            <Flex mr={3}>
                              <MdOutlineFilterAlt size={20} />
                            </Flex>
                            <Flex>
                              <Text fontWeight={600}>Filters </Text>
                              {filtersCountFn() > 0 && (
                                <Text
                                  ml={2}
                                  borderRadius={20}
                                  background={"white"}
                                  color={"black"}
                                  px={2}
                                  fontWeight={600}
                                >
                                  {filtersCountFn()}
                                </Text>
                              )}
                            </Flex>
                          </Flex>
                        </Button>
                      </PopoverTrigger>
                      <Portal>
                        <PopoverContent _focus={{ outline: 0 }}>
                          <PopoverArrow />
                          <PopoverHeader fontWeight={600}>
                            Filter Items
                          </PopoverHeader>
                          <PopoverCloseButton />
                          <PopoverBody>
                            <Accordion allowToggle _focus={{ outline: 0 }}>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box
                                      flex="1"
                                      textAlign="left"
                                      flexDir={"row"}
                                    >
                                      <Flex>
                                        <Text>Order Number</Text>
                                        {orderRef && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>

                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by Individual order
                                        number
                                      </Text>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Input
                                        color={textColor}
                                        mr={2}
                                        w={"30%"}
                                        disabled
                                        value={"PI"}
                                      />

                                      <Input
                                        color={textColor}
                                        placeholder={"EX: 04814"}
                                        type={"text"}
                                        onChange={(e) => {
                                          setOrderRef(e.target.value);
                                        }}
                                        value={orderRef}
                                      />
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>

                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Invoice Number</Text>

                                        {invoiceRef && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by Individual invoice
                                        number
                                      </Text>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Input
                                        color={textColor}
                                        mr={2}
                                        w={"30%"}
                                        disabled
                                        value={"INV"}
                                      />

                                      <Input
                                        color={textColor}
                                        placeholder={"EX: 004940"}
                                        type={"text"}
                                        id={"INVOICE_NO"}
                                        onChange={(e) => {
                                          setInvoiceRef(e.target.value);
                                        }}
                                        value={invoiceRef}
                                      />
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Sales Agent</Text>

                                        {agentRef && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by sales agents list
                                      </Text>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Menu placement={"top"}>
                                        <MenuButton
                                          as={Button}
                                          rightIcon={<MdArrowDropDown />}
                                        >
                                          {agentRef ? agentRef : "Sales Agents"}
                                        </MenuButton>
                                        <MenuList
                                          overflowY={"auto"}
                                          maxHeight={300}
                                        >
                                          {salesPersons?.body?.map(
                                            (item, i) => {
                                              return (
                                                <MenuItem
                                                  key={i}
                                                  color={textColor}
                                                  value={item?.salesperson_code}
                                                  fontSize={14}
                                                  onClick={(e) => {
                                                    setAgentRef(e.target.value);
                                                  }}
                                                >
                                                  {capitalizeFirstLetter(
                                                    item?.salesperson_name
                                                  )}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                        </MenuList>
                                      </Menu>

                                      {/*</Select>*/}
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Phone Number</Text>

                                        {mobileRef && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by phone number
                                      </Text>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Input
                                        color={textColor}
                                        mr={2}
                                        w={"40%"}
                                        disabled
                                        value={"+971"}
                                      />
                                      <Input
                                        color={textColor}
                                        placeholder={"EX: 058123456"}
                                        type={"number"}
                                        min={0}
                                        maxLength={10}
                                        id={"MOBILE_NUMBER"}
                                        onChange={(e) => {
                                          setMobileRef(e.target.value);
                                        }}
                                        value={mobileRef}
                                      />
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Emirates ID Number</Text>

                                        {emiratesRef && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by emirates id number
                                      </Text>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Input
                                        color={textColor}
                                        placeholder={"EX: 1234567891234"}
                                        type={"text"}
                                        value={emiratesRef}
                                        onChange={(e) => {
                                          setEmiratesRef(e.target.value);
                                        }}
                                      />
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Status</Text>

                                        {statusItemSelect.length > 0 && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            {statusItemSelect.length}
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by order status list
                                      </Text>
                                    </Flex>
                                    <Flex mt={2}>
                                      <Wrap>
                                        {statusItemSelect?.map((item, i) => (
                                          <WrapItem key={i}>
                                            <Tag
                                              size={"sm"}
                                              borderRadius="full"
                                              variant="solid"
                                              colorScheme="green"
                                            >
                                              <TagLabel>
                                                {capitalizeFirstLetter(
                                                  item?.status
                                                )}
                                              </TagLabel>
                                              <TagCloseButton
                                                onClick={(e) =>
                                                  statusListRemove(item?.status)
                                                }
                                              />
                                            </Tag>
                                          </WrapItem>
                                        ))}
                                      </Wrap>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"} zIndex={999}>
                                      <Menu>
                                        <MenuButton
                                          as={Button}
                                          rightIcon={<MdArrowDropDown />}
                                        >
                                          Select status
                                        </MenuButton>
                                        <MenuList>
                                          {status?.body?.statuses?.map(
                                            (item, i) => (
                                              <MenuItem
                                                key={i}
                                                color={textColor}
                                                value={item}
                                                onClick={(e) =>
                                                  handleAdvancedFilter(
                                                    e,
                                                    "status"
                                                  )
                                                }
                                              >
                                                {statusItemSelect?.map(
                                                  (slectedItem, i) => (
                                                    <>
                                                      {slectedItem?.status ==
                                                        item && (
                                                        <Flex key={i} mr={2}>
                                                          <MdCheckCircle
                                                            color={"green"}
                                                            size={18}
                                                          />
                                                        </Flex>
                                                      )}
                                                    </>
                                                  )
                                                )}
                                                {capitalizeFirstLetter(item)}
                                              </MenuItem>
                                            )
                                          )}
                                        </MenuList>
                                      </Menu>
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>
                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Location</Text>

                                        {locationItemSelect.length > 0 && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            {locationItemSelect.length}
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Flex flexDir={"column"}>
                                    <Flex>
                                      <Text fontSize={"sm"}>
                                        You can search by location
                                      </Text>
                                    </Flex>
                                    <Flex mt={2}>
                                      <Wrap>
                                        {locationItemSelect?.map((item, i) => (
                                          <WrapItem key={i}>
                                            <Tag
                                              size={"sm"}
                                              borderRadius="full"
                                              variant="solid"
                                              colorScheme="green"
                                            >
                                              <TagLabel>
                                                {item?.location === ""
                                                  ? "Empty Zones"
                                                  : item?.location}
                                              </TagLabel>
                                              <TagCloseButton
                                                onClick={() =>
                                                  locationListRemove(
                                                    item?.location
                                                  )
                                                }
                                              />
                                            </Tag>
                                          </WrapItem>
                                        ))}
                                      </Wrap>
                                    </Flex>
                                    <Flex mt={3} flexDir={"row"}>
                                      <Menu placement={"top"}>
                                        <MenuButton
                                          as={Button}
                                          rightIcon={<MdArrowDropDown />}
                                        >
                                          Select location
                                        </MenuButton>
                                        <MenuList
                                          overflowY={"auto"}
                                          maxHeight={500}
                                        >
                                          <>
                                            {locations?.body?.locations?.map(
                                              (item, i) => (
                                                <MenuItem
                                                  key={i}
                                                  color={textColor}
                                                  value={item}
                                                  onClick={(e) =>
                                                    handleAdvancedFilter(
                                                      e,
                                                      "location"
                                                    )
                                                  }
                                                >
                                                  {locationItemSelect?.map(
                                                    (locationSelected) => (
                                                      <>
                                                        {locationSelected?.location ===
                                                          item && (
                                                          <Flex mr={2}>
                                                            <MdCheckCircle
                                                              color={"green"}
                                                              size={18}
                                                            />
                                                          </Flex>
                                                        )}
                                                      </>
                                                    )
                                                  )}

                                                  {item}
                                                </MenuItem>
                                              )
                                            )}
                                            <MenuItem
                                              color={textColor}
                                              value={""}
                                              onClick={(e) =>
                                                handleAdvancedFilter(
                                                  e,
                                                  "location"
                                                )
                                              }
                                            >
                                              {locationItemSelect?.map(
                                                (locationSelected, i) => (
                                                  <div key={i}>
                                                    {locationSelected?.location ===
                                                      "" && (
                                                      <Flex mr={2}>
                                                        <MdCheckCircle
                                                          color={"green"}
                                                          size={18}
                                                        />
                                                      </Flex>
                                                    )}
                                                  </div>
                                                )
                                              )}
                                              Empty Zones
                                            </MenuItem>
                                          </>
                                        </MenuList>
                                      </Menu>
                                    </Flex>
                                  </Flex>
                                </AccordionPanel>
                              </AccordionItem>

                              <AccordionItem _focus={{ outline: 0 }}>
                                <h2>
                                  <AccordionButton>
                                    <Box flex="1" textAlign="left">
                                      <Flex>
                                        <Text>Upcoming EMI Due</Text>

                                        {emiDues && (
                                          <Text
                                            ml={2}
                                            borderRadius={20}
                                            background={"gray"}
                                            color={"white"}
                                            px={"10px"}
                                            fontWeight={600}
                                          >
                                            1
                                          </Text>
                                        )}
                                      </Flex>
                                    </Box>
                                    <AccordionIcon />
                                  </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>
                                  <Checkbox
                                    isChecked={emiDues}
                                    onChange={() => {
                                      emiDues
                                        ? setEmiDues(false)
                                        : setEmiDues(true);
                                    }}
                                  >
                                    {" "}
                                    Get upcoming EMI dues only{" "}
                                  </Checkbox>
                                </AccordionPanel>
                              </AccordionItem>
                            </Accordion>
                          </PopoverBody>
                          <PopoverFooter>
                            <Flex justifyContent={"space-between"}>
                              <Button
                                colorScheme={"gray"}
                                ml={2}
                                onClick={() => filterButtonReset()}
                              >
                                Reset
                              </Button>

                              <Button
                                colorScheme={"pink"}
                                onClick={() => handleMultiFilter()}
                              >
                                Apply
                              </Button>
                            </Flex>
                          </PopoverFooter>
                        </PopoverContent>
                      </Portal>
                    </Popover>
                  </Flex>

                  <Flex>
                    {userRole === "Admin" && (
                      <Button
                        mx={3}
                        colorScheme={"blue"}
                        borderRadius={10}
                        onClick={handleExport}
                        isLoading={exportLoading}
                        loadingText="Exporting..."
                      >
                        <Flex flexDir={"row"}>
                          <Icon
                            color="white"
                            w="22px"
                            mr={2}
                            h="22px"
                            as={MdCloudDownload}
                          />
                          Export to CSV
                        </Flex>
                      </Button>
                    )}
                  </Flex>
                </Flex>
              </Flex>

              <Box
                maxHeight="calc(100vh - 400px)"
                overflowY="auto"
                overflowX="auto"
              >
                <Table {...getTableProps()}>
                {filteredDataBySearch?.length === 0 ? (
                  <Flex
                    flexDir={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Player
                      autoplay
                      loop
                      src="https://assets2.lottiefiles.com/packages/lf20_g4wqji2g.json"
                      style={{ height: "200px", width: "200px" }}
                    ></Player>

                    <Flex flexDir={"column"} justifyContent={"space-between"}>
                      <Text fontSize={"lg"} my={3}>
                        {searchTerm
                          ? "NO MATCHING RECORDS FOUND"
                          : "NO RECORDS YET"}
                      </Text>
                      <Button my={3} onClick={filterButtonReset}>
                        Reset
                      </Button>
                    </Flex>
                  </Flex>
                ) : (
                  <>
                    <Thead
                      position="sticky"
                      top={-8}
                      bg="white"
                      zIndex={2}
                      boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                      borderTop="1px solid white"
                    >
                      {headerGroups.map((headerGroup, i) => (
                        <Tr key={i} {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <Th {...column.getHeaderProps()}>
                              {column.render("Header")}
                            </Th>
                          ))}
                        </Tr>
                      ))}
                    </Thead>

                    <Tbody {...getTableBodyProps()}>
                      <>
                        {page.map((row, i) => {
                          prepareRow(row);
                          return (
                            <Tr
                              key={i}
                              cursor={"pointer"}
                              _hover={{
                                background: "rgba(81, 81, 81, 0.16)",
                                textDecoration: "underline",
                              }}
                              onClick={(e) => {
                                orderInit(row.cells[0]?.row?.original);
                              }}
                              {...row.getRowProps()}
                            >
                              {row.cells.map((cell, i) => {
                                return (
                                  <Td
                                    key={i}
                                    {...cell.getCellProps()}
                                    fontSize={{
                                      base: "md",
                                      md: "sm",
                                      xl: "sm",
                                    }}
                                  >
                                    {cell.render("Cell")}
                                  </Td>
                                );
                              })}
                            </Tr>
                          );
                        })}
                      </>
                    </Tbody>
                  </>
                )}
                </Table>
              </Box>
              {filteredDataBySearch?.length > 0 && (
                <Flex justifyContent="space-between" m={4} alignItems="center">
                  {!searchTerm && (
                    <Flex>
                      <Tooltip label="First Page">
                        <IconButton
                          onClick={() => {
                            setPageHook(1);
                          }}
                          isDisabled={pageHook === 1}
                          icon={<ArrowLeftIcon h={3} w={3} />}
                          mr={4}
                        />
                      </Tooltip>
                      <Tooltip label="Previous Page">
                        <IconButton
                          onClick={() => {
                            setPageHook((s) => (s === 0 ? 0 : s - 1));
                          }}
                          isDisabled={pageHook === 1}
                          icon={<ChevronLeftIcon h={6} w={6} />}
                        />
                      </Tooltip>
                    </Flex>
                  )}

                  <Flex alignItems="center">
                    <Text flexShrink="0" mr={4}>
                      Page{" "}
                      <Text fontWeight="bold" as="span">
                        {pageHook}
                      </Text>{" "}
                      of{" "}
                      <Text fontWeight="bold" as="span">
                        {Math.ceil(sales?.body?.total / per_page) || 1}
                      </Text>
                      {searchTerm && (
                        <Text as="span" ml={2} fontSize="sm" color="gray.500">
                          (filtered)
                        </Text>
                      )}
                    </Text>
                    <Menu>
                      <MenuButton as={Button} rightIcon={<MdArrowDropDown />} size="sm" variant="outline">
                        {per_page} per page
                      </MenuButton>
                      <MenuList>
                        <MenuItem onClick={() => {
                          setPer_page(25);
                          setPageHook(1);
                        }}>
                          25 per page
                        </MenuItem>
                        <MenuItem onClick={() => {
                          setPer_page(50);
                          setPageHook(1);
                        }}>
                          50 per page
                        </MenuItem>
                        <MenuItem onClick={() => {
                          setPer_page(100);
                          setPageHook(1);
                        }}>
                          100 per page
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </Flex>

                  {!searchTerm && (
                    <Flex>
                      <Tooltip label="Next Page">
                        <IconButton
                          onClick={() => {
                            setPageHook((s) => s + 1);
                          }}
                          isDisabled={
                            pageHook ===
                              Math.ceil(sales?.body?.total / per_page) ||
                            parseInt(sales?.body?.total / per_page) == 0
                          }
                          icon={<ChevronRightIcon h={6} w={6} />}
                        />
                      </Tooltip>
                      <Tooltip label="Last Page">
                        <IconButton
                          onClick={() => {
                            setPageHook(
                              Math.ceil(sales?.body?.total / per_page)
                            );
                          }}
                          isDisabled={
                            pageHook ===
                              Math.ceil(sales?.body?.total / per_page) ||
                            Math.ceil(sales?.body?.total / per_page) == 0
                          }
                          icon={<ArrowRightIcon h={3} w={3} />}
                          ml={4}
                        />
                      </Tooltip>
                    </Flex>
                  )}

                  <OrderDrawer
                    selectedOrder={selectedOrder}
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                    setSelectedOrder={setSelectedOrder}
                  />
                </Flex>
              )}
            </Card>
          </Skeleton>
        </Box>
      </Box>
    </>
  );
}

export default Sales;
